import React from "react";
import { Table, Header } from "semantic-ui-react";
import { getDatePart } from "@common/components/helpers/datetime";
import { UKDateFormat } from "@common/constants/datetime";

const PrimaryCustomer = ({ primaryCustomer }) => {
    return (
        <Table  celled collapsing compact className="border-blue">
            <Table.Header>
            <Table.Row>
                <Table.HeaderCell colSpan='2'>
                <Header as='h4' >
                    Primary customer
                </Header>
                </Table.HeaderCell>
                <Table.HeaderCell></Table.HeaderCell>
            </Table.Row>
            </Table.Header>
            <Table.Body>
            <Table.Row>
                <Table.Cell>Name</Table.Cell>
                <Table.Cell>{`${primaryCustomer?.customer?.forename} ${primaryCustomer?.customer?.surname} (ID: ${primaryCustomer?.customer?.id})`}</Table.Cell>
            </Table.Row>
            <Table.Row>
                <Table.Cell>Home Venue</Table.Cell>
                <Table.Cell>{primaryCustomer?.customer?.site?.name}</Table.Cell>
            </Table.Row>
            <Table.Row>
                <Table.Cell>Age Range</Table.Cell>
                <Table.Cell>{primaryCustomer?.customer?.ageRange?.name}</Table.Cell>
            </Table.Row>
            <Table.Row>
                <Table.Cell>Gender</Table.Cell>
                <Table.Cell>{primaryCustomer?.customer?.gender?.name}</Table.Cell>
            </Table.Row>
            <Table.Row>
                <Table.Cell>Ethnicity</Table.Cell>
                <Table.Cell>{primaryCustomer?.customer?.ethnicity?.name}</Table.Cell>
            </Table.Row>
            <Table.Row>
                <Table.Cell>Date Created</Table.Cell>
                <Table.Cell>{getDatePart(primaryCustomer?.customer?.dateCreated, UKDateFormat)}</Table.Cell>
            </Table.Row>
            </Table.Body>
        </Table>
    )
}

export default PrimaryCustomer;